import React from 'react';
import { Link, useRecordContext, useResourceContext } from 'react-admin';
import { userFields } from '../../user.model';

const UserLinkField = ({ source, label, addLabel = true }) => {
    const record = useRecordContext();
    const resource = useResourceContext();

    if (!record || !source) {
        return null;
    }

    const value = record[source];
    if (!value) {
        return <span>n/a</span>;
    }

    return (
        <Link to={`/${resource}/${value}/show`}>
            {value}
        </Link>
    );
};

export default UserLinkField;
